import React, { CSSProperties, ReactNode } from 'react';
import { Chip, Tooltip, TooltipProps } from '@mui/material';
import { PaletteName } from '../layout/theme';

export type StatusChipProps = {
  text: ReactNode;
  color?: PaletteName;
  tooltip?: {
    style?: CSSProperties;
    content: ReactNode;
    placement?: TooltipProps['placement'];
  };
  style?: CSSProperties;
};

const StatusChip = ({ text, color, tooltip, style }: StatusChipProps) => {
  const palette = color ?? 'danger';
  // const { style: tooltipStyle, content: tooltipContent, placement: tooltipPlacement = 'bottom-start' } = tooltip || {};
  const { content: tooltipContent, placement: tooltipPlacement = 'bottom-start' } = tooltip || {};
  return (
    <Tooltip
      title={tooltipContent}
      placement={tooltipPlacement}
      slotProps={{
        popper: {
          // sx: tooltipStyle && { '& .MuiTooltip-tooltip': tooltipStyle },
        },
      }}
    >
      <Chip
        sx={{
          color: theme => theme.palette[palette].contrastText,
          backgroundColor: theme => theme.palette[palette].main,
          height: '1.25rem',
          fontSize: '75%',
          fontWeight: '700',
          whiteSpace: 'nowrap',
          ...style,
        }}
        label={text}
      />
    </Tooltip>
  );
};

export { StatusChip };
